import type { ReactNode } from "react";
import { forwardRef } from "react";

import type { IWidget } from "app/components/widget/widget-types/Widget";
import { MemoizedWidgetV2 } from "app/dashboards/view-components/Widget-v2";
import {
    DashboardWidgetContainer,
    DashboardWidgetHolder,
    GridResizableHandle,
} from "app/pages/dashboard/DashboardStyles-v2";

export const CustomGridItemComponent = forwardRef<
    HTMLInputElement,
    {
        style?: any;
        className?: string;
        widget: IWidget<any>;
        key?: any;
        onEdit: (widget) => void;
        onToggleEnlarge: (widget: IWidget<any>) => void;
        setChart?: (chart) => void;
        isStatic?: boolean;
        children?: ReactNode;
    }
>(({ style, className, widget, key: _key, onEdit, onToggleEnlarge, setChart, children, isStatic, ...props }, ref) => {
    return (
        <DashboardWidgetContainer
            style={{ ...style }}
            className={className}
            ref={ref}
            {...props}
        >
            <DashboardWidgetHolder>
                {children}
                <MemoizedWidgetV2
                    widget={widget}
                    onEdit={onEdit}
                    onToggleEnlarge={onToggleEnlarge}
                    setChart={setChart}
                    isStatic={isStatic}
                />
            </DashboardWidgetHolder>
        </DashboardWidgetContainer>
    );
});

CustomGridItemComponent.displayName = "CustomGridItemComponent";

export const ResizeHandleCmp = forwardRef<
    HTMLInputElement,
    { handleAxis?: string; className?: string; show?: boolean }
>((props, ref) => {
    const { handleAxis: _handleAxis, className = "", show, ...restProps } = props;
    return show ? (
        <GridResizableHandle
            ref={ref}
            className={`resizeHandle grid-no-drag ${className}`}
            {...restProps}
        >
            <svg
                width="6"
                height="32"
                viewBox="0 0 6 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    y="32"
                    width="32"
                    height="2"
                    rx="1"
                    transform="rotate(-90 0 32)"
                    fill="#E6E9EC"
                />
                <rect
                    x="4"
                    y="32"
                    width="32"
                    height="2"
                    rx="1"
                    transform="rotate(-90 4 32)"
                    fill="#E6E9EC"
                />
            </svg>
        </GridResizableHandle>
    ) : null;
});

ResizeHandleCmp.displayName = "ResizeHandleCmp";
